import queryString from 'query-string'

import TableStateType from '@/types/TableState'

/**
 * Table state mixin
 * Add :initial-state="tableState" in the targetted data table
 * Add call to updateTableState in the method(s) that fetch content using pagination
 * Override defaultTableSort to specify a default sort and prevent injecting a sort for that
 * @mixin
 */
export default {
	data() {
		return {
			tableState: {},
			defaultTableSort: null, // Use field name with minus as prefix if descending
		}
	},
	created() {
		this.tableState = new TableStateType({
			page: this.$route.query.page,
			sort: this.$route.query.sort,
		})
	},
	methods: {
		updateTableState(pagination) {
			const { page, sort } = pagination
			const state = { ...this.$route.query }

			if (page && page > 1) {
				state.page = page
			} else {
				delete state.page
			}
			if (sort !== this.defaultTableSort) {
				state.sort = sort || '_id'
			} else {
				delete state.sort
			}

			const qs = queryString.stringify(state)

			// Skip the observer to prevent unpredictable entire page reload
			// eslint-disable-next-line no-restricted-globals
			history.replaceState({}, null, `${this.$route.path}${qs === '' ? qs : `?${qs}`}`)
		},
	},
}
